import React from 'react';
import AddPurchaseRegister from './AddPurchaseRegister';
import DeletePurchaseRegister from './DeletePurchaseRegister';
import { logAuditEvent } from '../../utils/auditLogger';

function PurchaseRegisterModal({ show, UserAction = 'Add', onClose, onSubmit, selectedRow, moduleName = 'Purchase Register' }) {
  if (!show) return null;

  const handleSubmit = (e, payload) => {
    const actionName = e?.target?.name || UserAction;
    try {
      const details = JSON.stringify({ PurchaseRegisterId: selectedRow?.PurchaseRegisterId || null, DealerId: payload?.DealerId });
      const actionLabel = actionName === 'Edit' ? 'Edit Submit' : actionName === 'Delete' ? 'Delete Submit' : 'Add Submit';
      logAuditEvent(moduleName, actionLabel, details);
    } catch (e) {}
    onSubmit && onSubmit(e, { ...(payload || {}), PurchaseRegisterId: selectedRow?.PurchaseRegisterId || null });
  };

  const handleCancel = (label) => {
    logAuditEvent(moduleName, `${UserAction || 'Action'} ${label}`, `${label} clicked`)
    onClose()
  };

  return (
    <div className="modal d-block" tabIndex="-1">
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{UserAction} {moduleName}</h5>
              <button type="button" className="close" aria-label="Close" onClick={() => handleCancel('Close')}>
                <span aria-hidden="true">×</span>
              </button>
          </div>
          <div className="modal-body">
            {UserAction === 'Delete' ? (
              <DeletePurchaseRegister selectedRow={selectedRow} />
            ) : (
              <AddPurchaseRegister initialValues={selectedRow || {}} onSubmit={handleSubmit} moduleName={moduleName} formId={'purchaseRegisterForm'} />
            )}
          </div>
          <div className="modal-footer">
            {UserAction === 'Delete' ? (
              <>
                <button type="button" className="btn btn-cancel me-2" onClick={onClose}>Cancel</button>
                <button type="button" name="Delete" className="btn btn-danger" onClick={(e) => handleSubmit(e, {})}>Delete</button>
              </>
            ) : (
              <>
                <button type="button" className="btn btn-cancel me-2" onClick={onClose}>Cancel</button>
                <button type="button" name={UserAction} className="btn btn-submit" onClick={() => {
                  const form = document.getElementById('purchaseRegisterForm');
                  if (form && typeof form.requestSubmit === 'function') {
                    form.requestSubmit();
                  } else if (form) {
                    form.submit();
                  }
                }}>Submit</button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PurchaseRegisterModal;
